export default "__VITE_ASSET__CZzhekoq__"